import { InfoOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';
import { t } from 'i18next';
import { Resources, Translation } from '../../@types/i18next';
import { Dialog, DialogBody, DialogButtons } from './Modal/Modal';
import { Interpolation } from '../../config/i18n/components/Interpolation';
import { DangerButton, TertiaryButton } from '../../modal-flows/components/Buttons';

type Props = {
  title: Translation<Resources>;
  tip: Translation<Resources> | null;
  onClosed: (confirmUnlink: boolean) => void;
};

export const UnlinkIntegrationModal = ({ title, tip, onClosed }: Props) => {
  return (
    <Dialog
      onDismiss={() => onClosed(false)}
      title={t('integrationList.unlinkModal.unlinkTitle', { integration: t(title) })}
      subtitle={t('integrationList.unlinkModal.unlinkSubtitle')}
    >
      {tip && (
        <DialogBody>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'grey.700' }}>
            <InfoOutlined fontSize="small" />
            <Interpolation i18nKey={tip} />
          </Box>
        </DialogBody>
      )}
      <DialogButtons>
        <TertiaryButton onClick={() => onClosed(false)}>{t('integrationList.unlinkModal.goBack')}</TertiaryButton>
        <DangerButton autoFocus onClick={() => onClosed(true)}>
          {t('integrationList.unlinkModal.unlink')}
        </DangerButton>
      </DialogButtons>
    </Dialog>
  );
};
